@if (!loading) {
  <sc-socket-search
    [searchInput]="searchInput"
    [selectedItem]="selectedUser"
    [acceptCustomValue]="acceptCustomValue"
    [inputRequired]="required"
    [displayFn]="displayFn"
    [socketURL]="socketURL"
    [hint]="hint"
    (clear)="clearSelection()"
    (itemSelected)="selectUser($event)"
    (search)="handleSearch($event)"
    placeholder="{{ fieldLabel | translate }}"
    errorMessage="{{ validatorMessage | translate }}">
    <ng-template let-state>
      <div class="flex items-center">
        @if (state.item.MatchType === 'AccessCard') {
          <mat-icon class="search-option__icon txt-gray">sell</mat-icon>
        } @else if (state.item.MatchType === 'Vehicle') {
          <mat-icon class="search-option__icon txt-gray">car_tag</mat-icon>
        }
        <span class="search-option">
          @if (state.item.Name || state.item.PhoneNumber || state.item.Email) {
            @if (state.item.Name) {
              <span [innerHTML]="state.item.Name | highlight: state.searchInputCtrl.value"></span>
            }
            @if (state.item.PhoneNumber) {
              <span
                [ngClass]="{ address: state.item.Name }"
                [innerHTML]="state.item.PhoneNumber | highlight: state.searchInputCtrl.value"></span>
            }
            @if (state.item.Email) {
              <span
                [ngClass]="{ address: state.item.Name || state.item.PhoneNumber }"
                [innerHTML]="state.item.Email | highlight: state.searchInputCtrl.value"></span>
            }
          } @else if (state.item.CustomerIdentificator) {
            <span [innerHTML]="state.item.CustomerIdentificator | highlight: state.searchInputCtrl.value"></span>
          }
        </span>
        <span class="operator-logo" *canSee="userType.Admin">
          <div class="flex-center">
            <img
              [matTooltip]="state.item.OperatorName"
              [src]="state.item.OperatorLogoURL || 'assets/img/current_c.svg'" />
          </div>
        </span>
      </div>
    </ng-template>
  </sc-socket-search>
}
